export const PRODUCT_MODAL = 'product-modal';
export const TRENDING_NOW_LIST = 'trending-now-list-desktop';
export const POPULAR_RETAILER_LIST = 'popular-retailer-list';
export const UNINSTALL_INTERVIEW = 'uninstall-interview';
export const X_PLATFORM_ON_SEARCH_PAGE = 'x-platform-on-search-page';
export const X_PLATFORM_ON_HOME_PAGE = 'x-platform-on-home-page';
export const CASH_OUT_PAY_PAL = 'paypal-cashout';
export const CASH_OUT_GIFT_CARDS = 'gift-cards-cashout';
